<template>
  <div class="profile-wrap">
    <div v-if="visibleProfile" id="profile" class="pd20">
      <ProfileHeader
        :languages="accountLanguages"
        :completionLeft="completionLeft"
        :completion="completion"
      ></ProfileHeader>
      <form id="changePasswordForm">
        <label class="editor-wrapper">
          <input
            type="text"
            v-model.trim="realName"
            class="editor"
            v-bind:placeholder="accountLanguages.realName"
          />
        </label>
        <label class="editor-wrapper">
          <div class="editor relative">
            <span class="common-title">{{ accountLanguages.gender }}</span>
            <div class="sex-box" id="J_sex_box">
              <i
                class="sex-icon splite"
                v-bind:class="{ male: sex == MALE, female: sex == FEMALE }"
              ></i>
              <button
                type="button"
                @click="switchSex"
                class="sex_radios splite"
              ></button>
              <div class="sex-box-text" id="J_sex_box_text">{{ sexText }}</div>
            </div>
          </div>
        </label>
        <label
          class="editor-wrapper"
          style="cursor: pointer"
          @click="showDatePicker('birthday')"
        >
          <div class="editor relative div-label">
            <span class="common-title span-label">{{
              accountLanguages.birthday
            }}</span>
            <!-- <input class="date-editor"  v-model="birthday"  type="date" :min="minBirthday" :max="maxBirthday"/> -->
            <span class="date-editor">{{ birthdayText }}</span>
          </div>
        </label>
        <template v-if="isTp || runInSdk">
          <label class="editor-wrapper tel">
            <span class="tel-code">+{{ phoneCode }}</span>
            <input
              type="tel"
              class="editor"
              v-model.trim="phone"
              v-bind:placeholder="accountLanguages.phone"
            />
          </label>
          <label class="editor-wrapper verification">
            <input
              type="number"
              class="editor"
              v-model.trim="verifyCode"
              v-bind:placeholder="accountLanguages.editVrfCodeTips"
            />
            <van-button
              class="verification-button"
              color="#57ae67"
              type="info"
              :loading="loadingTelButton"
              :loadingText="loadingTelButtonText"
              @click.prevent="getTelCode"
            >
              {{ accountLanguages.reGetVrfCode }}
            </van-button>
          </label>
        </template>

        <label class="editor-wrapper">
          <!-- 智轩：血月（360）文案特殊展示 -->
          <input
            class="editor"
            v-model.trim="id_card_number"
            :placeholder="
              this.isBdm ? 'Số CMND/CCCD' : 'số CMND/hộ chiếu/căn cước'
            "
          />
        </label>
        <label
          class="editor-wrapper"
          style="cursor: pointer"
          @click="showDatePicker('IDCard')"
        >
          <div class="editor relative div-label">
            <span class="common-title span-label">Ngày cấp</span>
            <!-- <input class="date-editor"  v-model="id_card_issue_date" :min="minIDCardDate"  :max="maxIDCardDate" type="date"/> -->
            <span class="date-editor">{{ IDCardDateText }}</span>
          </div>
        </label>
        <label class="editor-wrapper">
          <input
            type="text"
            v-model.trim="id_card_issue_region"
            class="editor"
            placeholder="Vui lòng nhập địa chỉ Nơi Cấp chính xác"
          />
        </label>
        <label class="editor-wrapper">
          <input
            type="text"
            v-model.trim="email"
            class="editor"
            placeholder="Vui lòng nhập địa chỉ E-mail chính xác"
          />
        </label>
        <label class="editor-wrapper">
          <input
            type="text"
            v-model.trim="address"
            class="editor"
            placeholder="Vui lòng nhập địa chỉ cư trú chính xác"
          />
        </label>
        <!-- <Agreements   v-on:changeAgreeTerms="selectTerm"> </Agreements> -->
        <!-- 智轩：血月（360）文案特殊展示 -->
        <label class="agree-wrapper">
          <button
            refs="ddd"
            data-asyncbtn
            class="btn account-setting-submit"
            type="button"
            @click="setProfile"
          >
            {{ this.isBdm ? 'Xác thực thông tin' : accountLanguages.submit }}
          </button>
        </label>
      </form>
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          v-if="showPicker"
          v-model="currentDate"
          type="date"
          item-height="64px"
          @confirm="confirmTime"
          :confirm-button-text="accountLanguages.confirm"
          :cancel-button-text="accountLanguages.cancel"
          :title="pickerTitle"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
        />
      </van-popup>
      <transition name="fade">
        <Dialog v-show="showDialog"></Dialog>
      </transition>
      <transition name="fade">
        <PopupWindow
          type="tips"
          @onCancel="showPopup = false"
          @onConfirm="showPopup = false"
          v-if="showPopup"
          :languages="accountLanguages"
          content="Đã xác thực tài khoản, trở lại tạo mới để chơi tiếp!"
        ></PopupWindow>
      </transition>
    </div>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
  </div>
</template>
<script>
import bridge from '../../utiles/bridge';
import tp from '../../utiles/tp';
import * as utils from '@store/ultile';
import {
  SEND_VGM_CODE,
  SET_USR_EXT_INFO_VGM,
  REFRESH_USER_JSON,
  SWITCH_PASSPORT_LANG
} from '../../store/passport/accountSetting';
import { validateVgmProfile, validatePhone } from '../../store/validator';
import AccountSettingMixins from '../../mixins/AccountSetting';
import { CLOSE_EVENT } from '../../components/Tips';
import { SHOW_TIPS_MSG, TOST } from '../../store/dialog';
import { EventBus } from '../../utiles';
// import Agreements from "../../components/passport/Agreements";
import ProfileHeader from '../../components/passport/ProfileHeader';
import Popup from 'vant/lib/popup';
import DatetimePicker from 'vant/lib/datetime-picker';
import VanButton from 'vant/lib/button';
import 'vant/lib/popup/style';
import 'vant/lib/datetime-picker/style';
import 'vant/lib/button/style';

const IS_TP = utils.getHrefParam('tp') === '1';
const SUBMIT_PROFILE = 'submitProfile';
const CURR_YEAR = new Date().getFullYear();
const MALE = 0;
const gameId = utils.getHrefParam('gameId') || '';
const COUNTER_TIME = 60;
const formatTime = (date, fmt) => {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  }
  return fmt;
};
export default {
  data() {
    return {
      realName: '',
      sex: MALE,
      sexText: '',
      birthday: new Date('2000/01/01'),
      phone: '',
      verifyCode: '',
      id_card_number: '',
      id_card_issue_date: new Date(`${CURR_YEAR - 15}/01/01`),
      id_card_issue_region: '',
      email: '',
      address: '',
      completion: 0,
      terms: true,
      MALE: 0,
      FEMALE: 1,
      showPicker: false,
      currentDate: '',
      pickerType: 'birthday',
      showPopup: false,
      isBdm: +gameId == 360, // 是否为血月
      loadingTelButton: false,
      loadingTelButtonText: `${COUNTER_TIME}s`,
      phoneCode: '84',
      runInSdk: bridge.runInsdk(),
      isPreview: utils.getHrefParam('preview') === '1',
      isTp: IS_TP,
      tpInst: IS_TP ? tp() : null,
      gameId: gameId,
      visibleProfile: true
    };
  },
  created() {
    EventBus.$on(CLOSE_EVENT, eventType => {
      if (SUBMIT_PROFILE == eventType) {
        this.doSetProfile();
      }
    });
    this.selectTerm(true);
    // 2024-04-07: 钟杏锋：越南实名认证页面固定显示越南语
    this.$store.commit(SWITCH_PASSPORT_LANG, 'vi-VN');
    // 是弹屏：越南FUNTAP越南实名弹屏，gevents的中间页面tanping.html在开启这个页面时已经调用初始化方法。这里不再调用
    // if (this.isTp) {
    //   // 弹屏展示
    //   this.tpInst.init(this.gameId, false, () => {
    //     console.error('tp_show');
    //   });
    // }
  },
  computed: {
    completionLeft() {
      return this.completion + '%';
    },
    currMonth() {
      let month = new Date().getMonth() + 1;
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      return month;
    },
    currDay() {
      let day = new Date().getDate();
      if (day >= 0 && day <= 9) {
        day = '0' + day;
      }
      return day;
    },
    minBirthday() {
      return '1901-01-01';
    },
    maxBirthday() {
      return `${this.isBdm ? CURR_YEAR : CURR_YEAR - 18}-${this.currMonth}-${
        this.currDay
      }`;
    },
    minIDCardDate() {
      return `${CURR_YEAR - 18}-01-01`;
    },
    maxIDCardDate() {
      return `${CURR_YEAR}-${this.currMonth}-${this.currDay}`;
    },
    minDate() {
      if (this.pickerType === 'birthday') {
        return new Date(this.minBirthday.replace(/-/gi, '/'));
      } else {
        return new Date(this.minIDCardDate.replace(/-/gi, '/'));
      }
    },
    maxDate() {
      if (this.pickerType === 'birthday') {
        return new Date(this.maxBirthday.replace(/-/gi, '/'));
      } else {
        return new Date(this.maxIDCardDate.replace(/-/gi, '/'));
      }
    },
    pickerTitle() {
      return this.pickerType === 'birthday'
        ? this.accountLanguages.birthday
        : 'Ngày cấp';
    },
    birthdayText() {
      return formatTime(this.birthday, 'yyyy-MM-dd');
    },
    IDCardDateText() {
      return formatTime(this.id_card_issue_date, 'yyyy-MM-dd');
    }
  },

  mixins: [AccountSettingMixins],
  methods: {
    close() {
      this.$store.dispatch(TOST, this.accountLanguages.v3Completed);
      if (this.isTp) {
        // 弹屏弹出来：使用closeWebview来关闭
        this.visibleProfile = false;
        setTimeout(() => {
          bridge.callSdkMethod('trackEvent', {
            eventName: 'custom_popup_window',
            eventKey: 'close_window',
            eventValue: {
              type: 'close'
            }
          });
          this.tpInst.sdkCloseWebview();
        }, 1500);
      } else {
        // 登录后弹出来：使用improveUserInfoSuccess来关闭
        setTimeout(() => {
          bridge.callSdkMethod('improveUserInfoSuccess', function () {});
          this.$store.dispatch(REFRESH_USER_JSON).then(res => {
            this.showPopup = true;
          });
        }, 1500);
      }
    },
    tpClickEvent(eventName, eventKey) {
      const baseInfo = {
        adId: this.tpInst?.tpInfo?.adList?.[0]?.popupId,
        adType: this.tpInst?.tpInfo?.adList?.[0]?.adType,
        adUrl: this.tpInst?.tpInfo?.adList?.[0]?.forwardLink,
        priority: this.tpInst?.tpInfo?.adList?.[0]?.priority,
        openType: this.tpInst?.tpInfo?.adList?.[0]?.openType,
        popupPosition: 0,
        pageNum: 1,
        popupEvent: this.tpInst?.tpInfo?.adList?.[0]?.eventName
      };
      this.tpInst.sendCustomClickData({
        eventName: 'custom_popup_window',
        eventKey: 'visit',
        eventValue: {
          type: 'click_button',
          ...baseInfo
        }
      });
    },
    showDatePicker(type) {
      this.pickerType = type;
      if (this.pickerType === 'birthday') {
        this.currentDate = this.birthday;
      } else {
        this.currentDate = this.id_card_issue_date;
      }
      this.$nextTick(() => {
        this.showPicker = true;
      });
    },
    confirmTime() {
      if (this.pickerType === 'birthday') {
        this.birthday = this.currentDate;
      } else {
        this.id_card_issue_date = this.currentDate;
      }
      this.$nextTick(() => {
        this.showPicker = false;
      });
    },
    switchSex() {
      this.sex = (this.sex + 1) % 2;
    },
    async setProfile() {
      if (this.isPreview) return;
      await this.validateInfo();
      var tips = this.accountLanguages.canotModifyTips;
      this.$store.dispatch(SHOW_TIPS_MSG, {
        message: tips,
        tipsConfirmCallback: SUBMIT_PROFILE
      });
    },
    validateInfo() {
      const params = {
        real_name: this.realName,
        sex: this.sex + 1,
        birthday: this.birthdayText,
        phone: this.phone,
        verifyCode: this.verifyCode,
        id_card_number: this.id_card_number,
        id_card_issue_date: this.IDCardDateText,
        id_card_issue_region: this.id_card_issue_region,
        email: this.email,
        address: this.address,
        terms: this.terms
      };
      return new Promise((resolve, reject) => {
        const validateRes = validateVgmProfile(params);
        if (validateRes.dirty) {
          this.$store.dispatch(SHOW_TIPS_MSG, {
            message: validateRes.errmsg
          });
        } else {
          resolve();
        }
      });
    },
    doSetProfile() {
      const params = {
        real_name: this.realName,
        sex: this.sex + 1,
        birthday: this.birthdayText,
        phone: this.phone,
        id_card_country: 'VN',
        phone_code: this.phoneCode,
        id_card_number: this.id_card_number,
        id_card_issue_date: this.IDCardDateText,
        id_card_issue_region: this.id_card_issue_region,
        email: this.email,
        address: this.address,
        terms: this.terms,
        vgm_code_verify: this.runInSdk ? 1 : 0,
        vgm_code: this.verifyCode
      };

      this.$store
        .dispatch(SET_USR_EXT_INFO_VGM, params)
        .then(() => {
          this.close();
        })
        .catch(err => {
          this.$store.dispatch(SHOW_TIPS_MSG, {
            message: err.message
          });
        });
    },
    getTelCode() {
      if (this.isPreview) return;
      const validateRes = validatePhone(this.phone);
      if (validateRes.dirty) {
        this.$store.dispatch(SHOW_TIPS_MSG, {
          message: validateRes.errmsg
        });
        return;
      }

      if (this.loadingTelButton) return;
      this.loadingTelButton = true;
      let count = COUNTER_TIME;
      let timer = setInterval(() => {
        this.loadingTelButtonText = `${--count}s`;
        if (count <= 0) {
          this.loadingTelButton = false;
          clearInterval(timer);
        }
      }, 1000);

      this.$store
        .dispatch(SEND_VGM_CODE, {
          phone_code: this.phoneCode,
          phone: this.phone
        })
        .catch(errmsg => {
          this.$store.dispatch(SHOW_TIPS_MSG, {
            message: errmsg
          });
          this.loadingTelButton = false;
          clearInterval(timer);
        });
    }
  },
  components: {
    // Agreements,
    ProfileHeader,
    'van-datetime-picker': DatetimePicker,
    'van-popup': Popup,
    'van-button': VanButton
  },
  watch: {
    sex(newVal) {
      this.sexText =
        newVal === MALE
          ? this.accountLanguages.male
          : this.accountLanguages.female;
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-wrap {
  border: 1px solid #ffffff;
  background-color: #ffffff;

  &:before {
    z-index: -1;
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
}
</style>

<style>
.van-picker__cancel,
.van-picker__confirm {
  font-size: 20px;
}
</style>
